import gatewayFormConfig from './gatewayFormConfig';

const getPardotUrlForSelectedSlugId = (payload) => {
  const { country, locale, slugId } = payload;
  const selectedPardotForm =
    gatewayFormConfig && gatewayFormConfig.length !== 0
      ? gatewayFormConfig.filter((item) => {
          if (
            item.country === country &&
            item.locale === locale &&
            item.slugId === slugId
          ) {
            return item;
          }
        })
      : [];
  return selectedPardotForm.length !== 0
    ? selectedPardotForm[0].link
    : undefined;
};

const isPardotTrueExistInUrl = (urlPath) => {
  return urlPath && urlPath.includes('?pardot=true');
};

const isLeadFormKeyExist = (leadFormKey) => {
  return leadFormKey === 'Y' ? true : false;
};

const checkSlugIdExist = (payload) => {
  const { country, locale, slugId } = payload;
  const selectedPardotForm =
    gatewayFormConfig && gatewayFormConfig.length !== 0
      ? gatewayFormConfig.filter((item) => {
          if (
            item.country === country &&
            item.locale === locale &&
            item.slugId === slugId
          ) {
            return item;
          }
        })
      : [];
  return selectedPardotForm.length !== 0 ? true : false;
};

export {
  getPardotUrlForSelectedSlugId,
  isPardotTrueExistInUrl,
  isLeadFormKeyExist,
  checkSlugIdExist,
};
